import { API_REQUEST, TAKE_SURVEY } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

export const submitSurvey = (userProfileId: string, result: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/survey/update/${userProfileId}/${result}`,
        next: TAKE_SURVEY,
        method: 'GET',
        authorization: false
    }
});